<div class="full-height layout-column overflow-x-auto-only">

  <div class="layout-row layout-align-start-center padding-10">
    <app-bringoz-search-input class="flex-20"
                              [query]="filters.query"
                              placeholder="Search Agent"
                              minLength="3"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>
  </div>

  <app-dashboard-agents-table class="flex"
                              [agents]="agents"
                              (fetchNextEvent)="getNextBatch()">

  </app-dashboard-agents-table>

  <loader [isDisplayLoader]="isLoadingData"></loader>

</div>


